import { adminStore } from "stores/admin.store";
export const usePermissions = () => {
  const { userProfile } = adminStore();
  const permissions = userProfile?.permissions;

  const hasPermission = (requiredPermissions) => {
    if (!requiredPermissions || requiredPermissions.length === 0) {
      return true;
    }
    if (Array.isArray(requiredPermissions)) {
      return requiredPermissions.every((p) => permissions?.includes(p));
    }
  };

  return hasPermission;
};
